import { array, string, record } from 'fp-ts';
import { CommanderThunkAction } from '@mews-commander/types';
import { getCultureCode } from '@mews-commander/core';
import { getCultureInfos, getTexts, fetchTexts, fetchCultureInfo } from '@mews-commander/core/legacy-globalization';
import { getTextLocalizationInfo } from '../../../core/globalization/selectors';

export const fetchCultureInfos = (): CommanderThunkAction => async (dispatch, getState) => {
    const state = getState();
    const currentCultureCode = getCultureCode();
    const cultureInfos = getCultureInfos(state);

    // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
    if (!cultureInfos[currentCultureCode]) {
        return dispatch(fetchCultureInfo(currentCultureCode));
    }

    return Promise.resolve();
};

export const fetchLocalizedTexts = (): CommanderThunkAction => async (dispatch, getState) => {
    const state = getState();
    const texts = getTexts(state);
    const { languageCodes } = getTextLocalizationInfo(state);

    const uniqueLanguageCodes = array.uniq(string.Ord)(languageCodes);
    const existingLanguageCodes = record.keys(texts);
    const missingLanguageCodes = array.difference(string.Ord)(existingLanguageCodes)(uniqueLanguageCodes);

    if (array.isNonEmpty(missingLanguageCodes)) {
        return Promise.all(array.map(async (lCode: string) => dispatch(fetchTexts(lCode)))(missingLanguageCodes));
    }

    return Promise.resolve();
};
